import useAuthenticatedWebsocket from './useAuthenticatedWebSocket';

export default function useEditMessage() {
  const { sendJsonMessage } = useAuthenticatedWebsocket();

  return (messageDeliveryToken, text) => sendJsonMessage({
    action: 'edit_message',
    body: {
      delivery_token: messageDeliveryToken,
      text,
    },
  });
}
